<!-- 주문 기본 설정 -->
<template>
  <div>
    <div class="box">
      <admin-box-item title="결제방식 설정">
        <div class="column is-full">
          <!--<lp-check-group :list="paymentTypeArr"
                          :data="value.pay_type"
                          value_name="value"
                          label_name="label"></lp-check-group>-->
          <div v-for="(item,idx) in value.paylist" :key="`paylist-${idx}`">
            <admin-form-item :label="item.label">
              <div v-for="(item2,idx2) in item.pay_type" :key="`item-${idx2}`">
                <lp-check-bool :checkedVal.sync="item2.enable"
                               :label="item2.label"></lp-check-bool>
              </div>
            </admin-form-item>
          </div>
        </div>
        <div class="column is-full" v-if="enableNoBank">
          <admin-form-item label="무통장 입금 계좌">
            <div class="columns is-multiline">
              <div class="column is-3">
                  <span class="select">
                    <select v-model="value.bank.bank" @change="e=> value.bank.bank = e.target.value">
                      <option value="" disabled selected>은행 선택</option>
                      <option v-for="(bank,idx) in bankArr" :key="'bank-'+idx">{{ bank.label }}</option>
                    </select>
                  </span>
              </div>

              <div class="column is-6">
                <input class="input"
                       :value="value.bank.account_num"
                       @input="e=> value.bank.account_num = e.target.value"
                       placeholder="계좌번호"
                       type="text">
              </div>

              <div class="column is-3">
                <input class="input"
                       :value="value.bank.name"
                       @input="e=> value.bank.name = e.target.value"
                       placeholder="계좌주"
                       type="text">
              </div>
            </div>
          </admin-form-item>
        </div>
      </admin-box-item>
    </div>
    <div class="box">
      <admin-box-item title="주문 기본 설정">
      <div class="columns is-multiline lp-setting"
           v-for="(autoSetting, idx) in autoSettings" :key="'auto-setting-'+idx">
        <!-- 자동 배송완료 -->
        <div class="column is-full">
          <admin-form-item :label="'자동 ' + autoSetting.label">
            <lp-radio :val="value[autoSetting.value]"
                      @onSelect="res=> value[autoSetting.value] = res"
                      value_name="value"
                      label_name="label"
                      :data="autoSetting.options"></lp-radio>
          </admin-form-item>
        </div>
        <div class="column is-full" v-if="value[autoSetting.value]">
          <admin-form-item>
            <div class="flex flex-center">
            <input class="input"
                   style="width:40px"
                   v-model="value[autoSetting.value+'_day']"
                   @input="e=>setNumber(e, autoSetting.value+'_day', 3)"
                   type="number">
              <div style="margin-left:4px">일 후 자동 상태 변경</div>
            </div>
          </admin-form-item>
        </div>
      </div>
    </admin-box-item>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckGroup from "../../../module/common/LpCheckGroup";
  import LpInputText from "../../../module/common/LpInputText";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import AdminFormItem from "../../../module/admin/AdminFormItem";
  export default {
    name: "OrderSetting",
    components: {
      AdminFormItem,
      LpCheckBool,
      LpInputText, LpCheckGroup, LpRadio},
    props: {
      conversionType: {
        type: Number
      }
    },
    data() {
      return {
        // 결제 방식
        paymentTypeArr: [
          {label: '신용카드', value: 0},
          // {label: '휴대폰결제', value: 1},
          {label: '무통장 입금', value: 2},
          // {label: '실시간 계좌이체', value: 3},
          // {label: '가상계좌', value: 4},
        ],
        value: {
          success_delivery: false,
          success_delivery_day: 7,
          success_order: false,
          success_order_day: 7,
          cancel_paid: false,
          cancel_paid_day: 7,
          delay_delivery: false,
          delay_delivery_day: 7,
          pay_type: [0],
          bank: {
            name: '',
            bank: '',
            account_num: ''
          }
        },
        autoSettings: [
          {
            label: '배송완료',
            value: 'success_delivery',
            options:[
              { label: '배송중 -> 배송완료', value: true },
              { label: '사용안함', value: false }
            ]
          },
          {
            label: '구매확정',
            value: 'success_order',
            options:[
              { label: '배송완료 -> 구매확정', value: true },
              { label: '사용안함', value: false }
            ]
          },
          {
            label: '결제취소',
            value: 'cancel_paid',
            options:[
              { label: '미입금 -> 결제취소', value: true },
              { label: '사용안함', value: false }
            ]
          },
          {
            label: '배송지연',
            value: 'delay_delivery',
            options:[
              { label: '상품준비중 -> 구매확정', value: true },
              { label: '사용안함', value: false }
            ]
          }
        ],
        bankArr: []
      }
    },
    computed: {
      enableNoBank () {
        let enable = false;
        if(this.value.paylist) {
          let basic = find(this.value.paylist, 'name', 'basic');
          if(basic) {
            let nobank = find(basic.pay_type, 'name', 'nobank');
            if(nobank) {
              if(nobank.enable) enable = true;
            }
          }
        }
        return enable;
      }
    },
    created() {
      this.$axios.get('public/banks').then(res=>{
        this.bankArr = res.data;
      });

      let packageName = '';
      // delivery
      if(this.conversionType === 3) {
        packageName = 'delivery';
        removeIndex(this.autoSettings,3);
      }
      // reservation
      else if(this.conversionType === 10) {
        packageName = 'reservation';
        this.autoSettings = [this.autoSettings[2]];
      }
      // booking
      else if(this.conversionType === 11) {
        packageName = 'booking';
        this.autoSettings = [this.autoSettings[2]];
      }
      // mart
      else if(this.conversionType === 12) {
        this.autoSettings = [this.autoSettings[0], this.autoSettings[2]];
      }

      this.$axios.get(this.getUrl('order/setting')).then(res=>{
        if(res.status===200){
          if(!res.data.pay_type) {
            res.data.pay_type = [0];
            res.data.bank = {
              name: '',
                bank: '',
                account_num: ''
            };
          }

          let value = this.cloneItem(res.data);
          if(!res.data.paylist) {
            value.paylist = [
              {
                name: 'basic',
                label: "기본",
                pay_type: [
                  {name: "nobank", label: "무통장입금", "value": false}
                ]
              }
            ]
          }
          this.value = value;
        }
      });

    },
    methods: {
      setNumber(e, type, max_length){
        if( e.target.value.length > max_length ) this.value[type] = e.target.value.substr(0,max_length);
        else this.value[type] = e.target.value;
      },
      setPayType (value) {
        let social_key = this.$store.getters.getServiceSetting.social_key;
        // if(social_key.kakao.cid && social_key.kakao.admin_key) {
        //   this.addPayType(value, 'simple', '간편결제', 'kakaopay', '카카오페이')
        // }
        // if(social_key.inicis.mid && social_key.inicis.sign_key) {
        //   this.addPayType(value, 'inicis', '이니시스', 'credit', '신용카드')
        //   this.addPayType(value, 'inicis', '이니시스', 'phone', '휴대폰 결제')
        //   this.addPayType(value, 'inicis', '이니시스', 'trans', '실시간 계좌이체')
        // }
        // else {
        //   this.removePayType(value, 'inicis')
        // }
      },
      // key_name: simple, key_label: 간편결제, pay_name: kakaopay, pay_label: 카카오페이
      addPayType (value, key_name, key_label, pay_name, pay_label) {
        let data = find(value.paylist, 'name', key_name);
        // 없을 경우
        if(!data) {
          let item = {
            name: key_name,
            label: key_label,
            pay_type: []
          }
          value.paylist.push(item)
        }
        let pay_item = find(value.paylist, 'name', key_name);
        let pay_type = find(pay_item.pay_type, 'name', pay_name);
        if(!pay_type) {
          pay_item.pay_type.push({name: pay_name, label: pay_label, "value": false});
        }
      },
      removePayType (value, key_name) {
        for(let i=0; i<value.paylist.length; i++) {
          let item = value.paylist[i];
          if(item.name===key_name) {
            removeIndex(value.paylist,i);
          }
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .lp-setting
    margin-bottom 32px !important
  .lp-setting:last-child
    margin-bottom 0 !important
</style>
